import './PriorityIndicator.css';

export const PriorityIndicator = ({ 
  text, 
  level = 3,
  className = '' 
}) => {
  // Determine which bars should be filled based on level
  const renderBars = () => {
    const bars = [];
    for (let i = 0; i < 3; i++) {
      const isFilled = i < level;
      bars.push(
        <div 
          key={i}
          className={`priority-indicator__bar ${
            isFilled ? 'priority-indicator__bar--filled' : 'priority-indicator__bar--gray'
          }`}
        />
      );
    }
    return bars;
  };

  return (
    <div className={`priority-indicator ${className}`.trim()}>
      <div className="priority-indicator__bars">
        {renderBars()}
      </div>
      <span className="priority-indicator__text">{text}</span>
    </div>
  );
};

